/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddApprovedEmailInfoRequest
 */
export interface AddApprovedEmailInfoRequest {
    /**
     * White listed and expected email
     * @type {string}
     * @memberof AddApprovedEmailInfoRequest
     */
    email: string;
}

/**
 * Check if a given object implements the AddApprovedEmailInfoRequest interface.
 */
export function instanceOfAddApprovedEmailInfoRequest(value: object): boolean {
    if (!('email' in value)) return false;
    return true;
}

export function AddApprovedEmailInfoRequestFromJSON(json: any): AddApprovedEmailInfoRequest {
    return AddApprovedEmailInfoRequestFromJSONTyped(json, false);
}

export function AddApprovedEmailInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddApprovedEmailInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function AddApprovedEmailInfoRequestToJSON(value?: AddApprovedEmailInfoRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

